export default __webpack_public_path__ + "static/media/route53.79ee7b84.svg";